import withShowHidePassword from 'components/common/hoc/withShowHidePassword/withShowHidePassword'
import styled from 'styled-components'
import { ShowHidePasswordField } from 'components/common/Fields'

const CustomShowHidePasswordField = styled(ShowHidePasswordField)`
  & + & {
    margin-top: 15px;
  }
`

export const registerPasswordField = name => withShowHidePassword({ name })(CustomShowHidePasswordField)
